<template>
    <b-overlay
        :show="mostrarLoader"
        opacity="0.50"
        rounded="sm"
        spinner-variant="primary"
        spinner-type="grow"
    >
        <div></div>
    </b-overlay>
</template>

<script>
import { BOverlay }  from 'bootstrap-vue'

import axios from "@/axios";

export default {
    components: {
        BOverlay
    },
    data() {
        return {
            mostrarLoader: false
        }
    },
    methods:{
        getProducto(){
            this.mostrarLoader = true
            axios.get(`api/plan/${this.$route.params.token}`)
                .then( response => {
                    var datosJSON = JSON.stringify([response.data])
                    localStorage.setItem('carritoLegalbytez', datosJSON)
                    this.mostrarLoader = false
                    this.$router.push({name: 'finalizar_compra'})
            })
        }
    },
    mounted() {
    if (this.$route.params.token) {
        localStorage.setItem('carritoLegalbytez', "[]")
        this.getProducto()
    } else {
        window.location.href = "https://www.legalbytez.com/404/"
    }
  },
}
</script>